const DATE_STRING_ISO_FORMAT = Object.freeze({
  iso: /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}[-+]\d{2}:\d{2}$/,
  zulu: /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/,

  isoWithCaptures: /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})\.(\d{3})([-+]\d{2}:\d{2})$/, // has 8 groups
  zuluWithCaptures: /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})\.(\d{3})Z$/, // has 7 groups
});

export default DATE_STRING_ISO_FORMAT;
